import React from 'react';
import { Box, FormControlLabel, Radio, RadioGroup } from '@mui/material';
import { PaymentMode } from '../collectPayment.types';

interface PaymentModeToggleProps {
  value: PaymentMode;
  onChange: (mode: PaymentMode) => void;
  disabled?: boolean;
  paymentType?: string;
}

const PaymentModeToggle: React.FC<PaymentModeToggleProps> = ({
  value,
  onChange,
  disabled = false,
  paymentType,
}) => {
  return (
    <Box sx={{ mb: 2 }}>
      <RadioGroup
        row
        value={value}
        onChange={(e) => onChange(e.target.value as PaymentMode)}
      >
        <FormControlLabel
          value="settle"
          control={
            <Radio
              disabled={disabled}
              sx={{
                color: '#d32f2f',
                '&.Mui-checked': {
                  color: '#d32f2f',
                },
              }}
            />
          }
          label="Settle Now"
          sx={{
            '& .MuiFormControlLabel-label': {
              fontSize: '14px',
              fontWeight: value === 'settle' ? 500 : 400,
            },
          }}
        />
        {paymentType !== 'ADVANCE' && (

          <FormControlLabel
            value="credit"
            control={
              <Radio
                disabled={disabled}
                sx={{
                  color: '#d32f2f',
                  '&.Mui-checked': {
                    color: '#d32f2f',
                  },
                }}
              />
            }
            label="Save Bill as Credit"
            sx={{
              '& .MuiFormControlLabel-label': {
                fontSize: '14px',
                fontWeight: value === 'credit' ? 500 : 400,
              },
            }}
          />
        )}
      </RadioGroup>
    </Box>
  );
};

export default PaymentModeToggle;
